export function nactiFormular(div) {
  Lc.log("div1", div);
  div.find(".dvVK").each(function() {
    let c = $(this);
    c.append(
      '<label>přidat výbavu <input class="inpVybava" type="text" size="20"> </label><input class="btn" type="button" value="pridat">'
    );
  }); //each

  div.find(".dvVK input.btn").click(function() {
    let dvK = $(this).closest(".dvVK");
    let inp = dvK.find("input.inpVybava");
    Lc.f("click");
    Lc.log("inp", inp);
    Lc.log("val", inp.val());

    $.post("/admin/ajax/ajax-nova-vybava.php", {
      nazev: inp.val(),
      kategorie: dvK.attr("data-id")
    }).done(function(data) {
      Lc.log(data); // JSON data parsed by `response.json()` call
      if (data.stav) {
        dvK
          .find(".dvA")
          .append(
            '<label class="lbCheck"><input type="checkbox" name="vybava[' +
              dvK.attr("data-id") +
              "~" +
              data.idVybavy +
              ']" value="' +
              dvK.attr("data-id") +
              "~" +
              data.idVybavy +
              '" checked><span class="nbsp">&nbsp;</span>' +
              inp.val() +
              "</label>"
          );
      }
    });
  }); //find
}
